import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import Swal from 'sweetalert2'; // Import SweetAlert2

import * as dao from './dao';
import * as utils from '../shared/utils';
import * as apiclient from '../shared/apiclient.service';
import { ValuesService } from '../shared/values.service';
import * as constants from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class StateService {
		
	constructor(){ };
		
	private situationNatureSubject: BehaviorSubject<dao.SituationNatures> = new BehaviorSubject<dao.SituationNatures>([new dao.SituationNature(new Date(), undefined, undefined, undefined, dao.SituationSpecifique.NONE, undefined), new dao.SituationNature(new Date(), undefined, undefined, undefined, dao.SituationSpecifique.NONE)]);
	
	public situationNature$: Observable<[dao.SituationNature, dao.SituationNature]> = this.situationNatureSubject.asObservable();
	
	// Computes a newSituationNature and emits a new situationNatureSubject
	// typ_pj_amo=0 for CV situationNature, 1 for ADR 
	public getCalculatedSns(beneficiaire: dao.Beneficiaire | undefined, codeRegime: string | undefined, codeGest: string | undefined, referenceDate: Date, typ_pj_amo: number): dao.SituationNatures {	// See M'CDC_v8.40_#CDC_Complet p 248
			console.log(`[StateService specificCasesDetection] referenceDate: ${referenceDate} - ${(typ_pj_amo==constants.TYP_PJ_AMO_CV?'CV':'ADR')}\n${JSON.stringify(beneficiaire, null, 2)}`);
      // Clone current state to avoid mutating the BehaviorSubject's internal value directly
      let currentSns: dao.SituationNatures = [...this.situationNatureSubject.value];
			
			let newSituationNature:dao.SituationNature = this.getSituationNature(beneficiaire, referenceDate, typ_pj_amo);	// Set active flags for AMO, periodeCouverture, AMC
			console.log(`[StateService specificCasesDetection] newSituationNature: %c${JSON.stringify(newSituationNature, null, 4)}`, 'background: yellow;');
			newSituationNature.codeRegime =  codeRegime;						// Push codeRegime. Useful when only a SituationNature is available
			
			// Determination du mode gestion - Cas général, peut être forçé par la suite
			if (beneficiaire?.donneesMutuelle) {
				newSituationNature.modeGestion = dao.ModeGestion.GU;
			} else if (beneficiaire?.donneesAMC) {
				newSituationNature.modeGestion = dao.ModeGestion.GS;
			} 
			
			// Special case is first. Could be overwritten later
			if (beneficiaire?.donneesAMC && beneficiaire.donneesAMC.active && (beneficiaire?.donneesAMC.indicTraitAMC =='63' || beneficiaire?.donneesAMC.indicTraitAMC =='62')) {	// Cas particulier. IT 62/63 => Possible C2S. CTF 1.15.01
				newSituationNature.sp = dao.SituationSpecifique.SP03d;
				newSituationNature.modeGestion = dao.ModeGestion.GS;			// Process SP03d like a GS
				//newSituationNature.modeGestion = dao.ModeGestion.NONE;	// Force mode gestion inconnu
			}		
			
			if (codeRegime == '01' && codeGest && codeGest==constants.MIGRANT_AUTRE) {
				newSituationNature.sp = dao.SituationSpecifique.SP082;
				newSituationNature.msgdebug = "Code régime/gestion=01/70 => BS permanent coordonné RSS"; // Ex Autre situation de migrant
				newSituationNature.isDroitsOuverts = newSituationNature.isDroitsAMO;	// Droit résultant == droit AMO actif
			}
			if (codeGest && codeGest==constants.VICTIME_ATTENTAT) {   // Article L.115 Test EV95-3
        newSituationNature.isAttentat = true;
				//newSituationNature.sp = dao.SituationSpecifique.SP18;
				//newSituationNature.msgdebug = "Bénéficiaire victime d'attentat, article L.115. Code gestion 13";      
				//newSituationNature.isDroitsOuverts = newSituationNature.isDroitsAMO;	
			}      
			if (codeRegime == '17') {										// BS CFE EV103-125 Caisse Français Etranger
				newSituationNature.sp = dao.SituationSpecifique.CFE;
				newSituationNature.msgdebug = "Code régime 17 => CFE"; // Ex Autre situation de migrant
				newSituationNature.isDroitsOuverts = newSituationNature.isDroitsAMO;	// Droit résultant == droit AMO actif
			} 
			if (beneficiaire?.codeSrvAMOBenef=='01') {	// Cas SP03a : C2S gérée par AMO => Gestion unique CTF 1.09a
				newSituationNature.sp = dao.SituationSpecifique.SP03a;
				newSituationNature.isDroitsOuverts = newSituationNature.isDroitsAMO;	// Droit résultant == droit AMO actif 
				newSituationNature.modeGestion = dao.ModeGestion.GU;
			}
			if (beneficiaire?.donneesMutuelle?.mutnum=='99999997') {	// Cas SP03a : C2S gérée par AMO => Gestion unique 
				newSituationNature.sp = dao.SituationSpecifique.SP03a;	// L'ouverture des droits dépends de l'activité de la période spécifique. FACT-SFG-014 CF [RG_CF317] [SP03], [RG_CF385] [SP03] et [RG_CF408]
				newSituationNature.isDroitsOuverts = newSituationNature.isDroitsAMO;	// Droit résultant == droit AMO actif
				newSituationNature.modeGestion = dao.ModeGestion.GU; 
			}			
			if (beneficiaire?.codeSrvAMOBenef=='02') {	// C2S gérée par AMC en convention => Gestion Unique (transmission directe)
				newSituationNature.sp = dao.SituationSpecifique.SP03b;
				newSituationNature.modeGestion = dao.ModeGestion.GU;
			}
			if (beneficiaire?.codeSrvAMOBenef=='03') {	// C2S gérée par AMC (pas de déduction) TODO séparer GU/GS selon donneesAMC Test ?
				newSituationNature.sp = dao.SituationSpecifique.SP03c;
				newSituationNature.modeGestion = dao.ModeGestion.GS;
			}
			if (newSituationNature.activePeriodeMutuelleIndex != undefined && beneficiaire?.donneesMutuelle?.mutnum=='88888888') {	// C2S gérée par AMC (GU par défaut) test 1.16 TODO isoler cas donneesAMC Test ?  
				newSituationNature.sp = dao.SituationSpecifique.SP03c;
				newSituationNature.modeGestion = dao.ModeGestion.GU;    // TODO should be 'indeterminé'
        //alert("
        Swal.fire({
          title: 'Le mode de gestion ne peut être déterminé',
          html: "C2S attribuée au bénéficiaire (MUTNUM=88888888).<br>Si une attestation complémentaire a été présentée, passer en mode <b>'Autre support de droit AMC'</b> pour la saisir.<br>Par défaut la facture sera en mode 'Tiers Payant Coordonné')",
          footer:"La stuation spécifique doit être positionnée à 'C2S gérée par AMC'",
          icon: 'warning',
          theme: 'material-ui',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
        }).then((result) => {
          if (result.isConfirmed) {
            // Your logic here (e.g., call a service)
            //Swal.fire('Deleted!', 'The item has been removed.', 'success');
          }
        });
			}
			
			if (beneficiaire?.codeSrvAMOBenef=='10' || ((newSituationNature.activePeriodeMutuelleIndex != undefined) && (beneficiaire?.donneesMutuelle?.mutnum=='55555551'))) {	// Sortant de C2S
				newSituationNature.sp = dao.SituationSpecifique.SP04;
			}		
			newSituationNature.msgspe = ((newSituationNature.sp != undefined && newSituationNature.sp != dao.SituationSpecifique.NONE)? dao.SituationSpecifiqueDescriptions[newSituationNature.sp]:'');
			
			// Dealing w/ msgu
			if (!beneficiaire?.donneesMutuelle && !beneficiaire?.donneesAMC) {	// No data => check codeSrvAMOBenef TODO take dates into account
				switch (beneficiaire?.codeSrvAMOBenef) {
					case '01':
						newSituationNature.msgu = 'Gestion Unique (par assimilation)';
						break;
					case '02':
						newSituationNature.msgu = 'Gestion Unique';
						break;
					case '03':
						newSituationNature.msgu = 'Mode de gestion indeterminé (vérifier les infos.)';
						break;								
				}
			} else if (beneficiaire?.donneesMutuelle && (newSituationNature.activePeriodeMutuelleIndex != undefined)) {	// Zone mutuelle renseignée && active
				switch (beneficiaire?.donneesMutuelle?.mutnum) {
					case '99999997':
						newSituationNature.msgu = 'Gestion Unique (par assimilation)';
						newSituationNature.msgdebug = 'MUTNUM à 99999997 => GU sur CV\nSupport AMC=CV';
						newSituationNature.isDroitsOuverts = newSituationNature.activePeriodeMutuelleIndex != undefined;	// Droit résultant == droit mutuelle actif
						break;
					case '88888888':
						newSituationNature.msgu = '';
						newSituationNature.msgdebug = 'MUTNUM à 88888888 => Gestion indet. Demander une att. AMC pour transmission directe';
						break;			
					case '55555551':
						newSituationNature.msgdebug = 'MUTNUM à 55555551 => Sortant C2S sur CV, \nTP AMC sur attestation';
						break;
					case '75500025':	// FACT-SFG-012 BS v8.60_CDC.pdf [SP06]
						newSituationNature.sp = dao.SituationSpecifique.SP06;
						newSituationNature.msgu = "Situation d'AME détectée";
						newSituationNature.msgdebug = 'MUTNUM à 75500025 => AME';
						break;						
					default:
						newSituationNature.msgu = 'AMC en Gestion Unique';
						break;
				}
			}	else if (!newSituationNature.msgu && beneficiaire?.donneesAMC) {	// Zone AMC renseignée	=> Séparé
								newSituationNature.msgu = 'AMC en Gestion séparée';
						}
			if (beneficiaire?.codeSrvAMOBenef =='03' && beneficiaire?.donneesAMC) {	// Special case
				newSituationNature.msgu = 'AMC en Gestion séparée';
				newSituationNature.msgdebug = 'Code service == "03"';
			}
			console.log('[StateService specificCasesDetection] PeriodeDroitsAMO: ', JSON.stringify(beneficiaire?.periodeDroitsAMO));
			console.log(`[StateService specificCasesDetection] newSituationNature emission: %c${JSON.stringify(newSituationNature, null, 4)}`,'color:white; background: green;');

			currentSns[typ_pj_amo] = newSituationNature;
      return currentSns;
		}	
		
  // 2. The "Noisy" version for the GUI (Triggers ngOnInit subscriptions)
  public specificCasesDetection(beneficiaire: dao.Beneficiaire | undefined, codeRegime: string | undefined, codeGest: string | undefined, referenceDate: Date, typ_pj_amo: number) {
      const sns = this.getCalculatedSns(beneficiaire, codeRegime, codeGest, referenceDate, typ_pj_amo);
      this.situationNatureSubject.next(sns); // Broadcast to the app
  }

	private getSituationNature(beneficiaire: dao.Beneficiaire | undefined, referenceDate: Date, typ_pj_amo: number): dao.SituationNature {	// Activate relevant periodeCodeCouverture block, emit related event
		let newSituationNature = new dao.SituationNature(referenceDate, undefined, undefined, undefined, dao.SituationSpecifique.NONE, undefined, '', '', '');
		newSituationNature.isDroitsAMO = false;	                                                    // Default to false. No periodeDroitsAMO => false
    if (typ_pj_amo==constants.TYP_PJ_AMO_ADR) {newSituationNature.isDroitsOuverts = false}       // ADRi => isDroitsOuverts defaults to false. Can only be opened by an active AMO period
		// Block periodeCodeCouverture
		console.log('\n%cBlock periodeCodeCouverture\n', 'background: #f5f5f5; color: #bada55');
		if (beneficiaire && beneficiaire.periodeCodeCouverture) {
			beneficiaire.periodeCodeCouverture.forEach((pc:dao.PeriodeCodeCouverture, index) => {
				// Set the active flag based on the isBlockActive result
				//console.log(`%c[getSituationNature] processing ${JSON.stringify(pc, null, 4)}`, 'color: white; background: #8e44ad');
				//console.log(`%c[getSituationNature] active ? ${this.isBlockActive(beneficiaire?.periodeCodeCouverture, index, referenceDate, typ_pj_amo)}`, 'color: white; background: #8e44ad');
				if (this.isBlockActive(beneficiaire?.periodeCodeCouverture, index, referenceDate, typ_pj_amo)) {	// active block changed
					//console.log(`%c[getSituationNature] found active block`, 'color: white; background: #8e44ad');
					pc.active = true;
					newSituationNature.pc = pc;												// Assign current situationNature.pc this pc
					if (pc.codeALD && pc.codeALD!='0') {							// Code ALD detecté
						newSituationNature.isALD = true;								// Set ALD flag for this recipient
						newSituationNature.msgu = "ALD detectée" + (newSituationNature.msgu?"<br>"+newSituationNature.msgu:newSituationNature.msgu);
					}
				} else if (!this.isBlockActive(beneficiaire?.periodeCodeCouverture, index, referenceDate, typ_pj_amo)) {
					//console.log(`%c[getSituationNature] current block is inactive`, 'color: white; background: #8e44ad');
					pc.active = false;
				}
			});
		} else {
			console.log('No periodeCodeCouverture available.');
		}

		// Block periodeDroitsAMO
		//console.log('\n%cBlock periodeDroitsAMO\n', 'background: #f5f5f5; color: #bada55');
		newSituationNature.activePeriodeAmoIndex = undefined;										// Reset activePeriodeAmoIndex
		if (beneficiaire && beneficiaire.periodeDroitsAMO) {
			beneficiaire.periodeDroitsAMO.forEach((pda, index) => {			// Loop over periodeDroitsAMO
				// Set the active flag based on the isBlockActive result
				if (this.isBlockActive(beneficiaire?.periodeDroitsAMO, index, referenceDate, typ_pj_amo)) {
					pda.active = true;
					newSituationNature.isDroitsAMO = true;									// Droits AMO actifs pour ce bénéficiaire
          newSituationNature.isDroitsOuverts = true;
					newSituationNature.activePeriodeAmoIndex = index;
				} else if (!this.isBlockActive(beneficiaire?.periodeDroitsAMO, index, referenceDate, typ_pj_amo)) {	// Droits AMO inactifs
					pda.active = false;
				}
			});
		} else {
			//console.log('No periodeDroitsAMO available.');
			newSituationNature.isDroitsOuverts = false;			// Pas de droit AMO => pas de droits résultats SAUF si ouverts via situation specif.
		}

		// Block periodeMutuelle (Gestion Unique)
		//console.log('\n%cBlock periodeMutuelle (GU)\n', 'background: #f5f5f5; color: #bada55');
		newSituationNature.activePeriodeMutuelleIndex = undefined;										// Reset activePeriodeMutuelleIndex
		if (beneficiaire && beneficiaire.donneesMutuelle?.periodeMutuelle) {
			beneficiaire.donneesMutuelle.periodeMutuelle.forEach((pm, index) => {				// Loop over periodeMutuelle
				//console.log(`[setActiveFlags] reading periodeMutuelle : ${JSON.stringify(pm)} - ${this.isBlockActive(beneficiaire?.donneesMutuelle?.periodeMutuelle, index, referenceDate, typ_pj_amo)}`, );
				// Set the active flag based on the isBlockActive result
				if (this.isBlockActive(beneficiaire?.donneesMutuelle?.periodeMutuelle, index, referenceDate, typ_pj_amo)) {
					//console.log(`[setActiveFlags] setting periodeMutuelle TRUE: ${JSON.stringify(pm)}`, );
					pm.active = true;
					newSituationNature.activePeriodeMutuelleIndex = index;
				} else {
					//console.log(`[setActiveFlags] setting periodeMutuelle FALSE: ${JSON.stringify(pm)}`, );
					pm.active = false;
				}
			});
		} else {
			console.log('%cNo periodeMutuelle (GU) available (could be GS).', 'color: silver');
		}

		// "fake Block"" donneesAMC
		if (beneficiaire && beneficiaire.donneesAMC) {
			beneficiaire.donneesAMC.active = this.isBlockActive([beneficiaire.donneesAMC], 0, referenceDate, typ_pj_amo);	// We build an artificial array to be compliant w/ method signature
		}
		//this.situationEmitter.emit(this.situationNature);		// Emit modified current (active) situationNature
		return newSituationNature;
	}
			
	private isBlockActive(blocks: any, i: number, referenceDate: Date, typ_pj_amo: number): boolean {
		let ret = false;
		if (!blocks || i < 0 || i >= blocks.length) { return false; } // Return false if the index is out of bounds 

		const pc = blocks[i];
		const dateDebut = (pc.dateDebut ? utils.getDateFromYYYYMMDD(pc.dateDebut) : undefined);
		const dateFin = (pc.dateFin ? utils.getDateFromYYYYMMDD(pc.dateFin) : undefined);

		// Check if referenceDate is valid
		if (!referenceDate) { console.error(`Invalid reference date from dateFacture: ${referenceDate}. Returning false.`); return false; }

		// Check the conditions
		if (dateDebut && dateFin) {
			//console.log(`    1 - ${dateDebut} -> ${dateFin}`);
			ret = (referenceDate >= dateDebut) && (referenceDate <= dateFin);
		} else if (dateDebut && !dateFin) {
			//console.log(`    2 - ${dateDebut} -> ${dateFin}`);
			ret = referenceDate >= dateDebut
		} else if (!dateDebut && dateFin) {
			//console.log(`    3 - ${dateDebut} -> ${dateFin}`);
			ret = referenceDate <= dateFin;
		} else if (!dateDebut && !dateFin) {
			//console.log(`    4 - ${dateDebut} -> ${dateFin}`);
			ret = true;
		}
		//console.log(`  [isBlockActive] ${(typ_pj_amo==constants.TYP_PJ_AMO_CV?'CV':'ADR')} index - active: ${i} - ${ret}`);
		return ret; // If both dateDebut and dateFin are undefined
	}
	
	get currentSituationNatureCV(): dao.SituationNature {	// Return CV part of situationNatureSubject
	  return this.situationNatureSubject.value[constants.TYP_PJ_AMO_CV];
	}

	get currentSituationNatureADR(): dao.SituationNature {	// Return ADR part
	  return this.situationNatureSubject.value[constants.TYP_PJ_AMO_ADR];
	}		
}
